import Axios from 'axios';
import Qs from 'qs';

export default {

  // 系统日志分页列表
  listPage(
    content,
    event,
    start_time,
    end_time,
    page,
    limit
  ) {
    return Axios.get('/systemLog/api/admin/system-log', {
      params: {
        filter: {
          content,
          event
        },
        start_time,
        end_time,
        sort: {
          id: 'desc'
        },
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  }

}